import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CustomInputClaro from '../../forms/CustomInputClaro';
import ButtonsRentForm from '../../payment/commons/ButtonsRentForm';
import { converter } from '../../../helpers/converter';
import FormValidations from '../../../data/FormValidations';
import RequestManager from '../../../requests/RequestManager';
import PaywayChangePaymentMethodTask from '../../../requests/tasks/user/PaywayChangePaymentMethodTask';
import * as actions from '../../../actions/response';

export class PaymentTelmexMexicoGate extends React.Component {
  constructor() {
    super();
    this.state = {
      form: {
        accountid: '',
      },
      errors: {},
      showPaymentView: true,
      loading: false,
    };
    this.validateForm = this.validateForm.bind(this);
    this.setFormState = this.setFormState.bind(this);
  }
  // TODO: REFACTOR -> Replace UNSAFE_componentWillMount with componentDidMount

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const form = {
      payway: 'telmexmexicogate',
    };
    this.setState({ form });
  }

  setFormState(event) {
    this.state.form[event.target.name] = event.target.value;
    return this.setState({ form: this.state.form });
  }

  isValidForm() {
    let formValid = true;
    this.state.errors = {};

    // Validaciones del campo telefono
    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.accountid, 'accountid')
        .validateMinLongitude(
          6,
          converter.convertApaUnicode(
            this.props.translations,
            'error_telefono_vacio',
          ),
        )
        .validateNumberFormat('El telefono debe tener 10 digitos')
        .getErrors(),
    );

    if (Object.keys(this.state.errors).length !== 0) {
      formValid = false;
    }

    this.setState({ errors: this.state.errors });
    return formValid;
  }

  userActive = () => {
    this.sendRequest();
  }

  renderView() {
    return this.state.showPaymentView ? (
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-4 col-xs-12">
          <p>
            Para cambiar tu forma de pago a Recibo Telmex/Telnor ingresa tu teléfono Telmex :
          </p>
        </div>
        <form id="carbiar-a-telefono">
          <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12 padding-top-05">
            <CustomInputClaro
              idElement="accountid"
              labelText="Número:"
              inputType="text"
              placeholderText="Número"
              additionalMessage=""
              componentClassName="form-group"
              labelClassName="col-lg-4 col-md-5 control-label hidden-sm hidden-xs"
              inputClassName="col-lg-8 col-md-7 col-sm-12 col-xs-12"
              onChange={this.setFormState}
              value={this.state.form.accountid}
              error={this.state.errors.accountid}
            />
          </div>
          <div className="row">
            <div className="col-lg-4 col-lg-offset-8 col-md-4 col-md-offset-8 col-sm-12 col-xs-12">
              {this.state.loading ? (
                <span id="cargando" className="full-width padding-2">
                  <img
                    alt="loading"
                    width="54"
                    className="center-block"
                    src="https://www.clarovideo.com/fe/sitesplus/sk_core/images/cargando.gif" />
                </span>
              ) : (
                <ButtonsRentForm
                  buttonsRentBlockClassName="row"
                  loadingBlockClassName="col-lg-4 col-md-4 col-sm-12 col-xs-12"
                  backBlockClassName="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                  confirmBlockClassName="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                  backButtonText="Atr&aacute;s"
                  translations={this.props.translations}
                  onClickConfirm={this.validateForm}
                  onClickBack={this.switchPayment}
                />
              )}
            </div>
          </div>
        </form>
      </div>
    ) : (
      <div className="row">
        <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
          <div className="form-group">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <p className="form-control-static">
                Ya tienes <b>Claro video </b>
                <strong>SIN COSTO</strong>*. Completa tu registro llamando desde el número que registraste al <b>01 800 252 9090</b> o ingresa al <b>Chat online</b> para activar el servicio.<br/>
              </p>
              <h4>
                <small>
                  * Telmex pagará el servicio de Claro video durante 12 meses. No incluye Pago por Evento.
                </small>
              </h4>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div className="row">
            <div
              className="col-lg-7 col-md-7 col-sm-12 col-xs-12"
              style={{ float: 'right' }}
            >
              <button
                type="button"
                className="btn btn-default btn-block margin-top-05"
                onClick={this.userActive}
              >
                Ya activé mi usuario
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getModal(modalProps) {
    const modal = {
      modalType: modalProps.modalType,
      props: {
        message: modalProps.msg,
        onAccept: modalProps.onAccept,
      },
    };
    return modal;
  }

  onSuccess(data) {
    let modal = null;
    let modalProps = {};
    const isFail =
      data.response &&
      data.response.status &&
      (data.response.status === 'FAIL' || data.response.status === 'error');

    this.setState({ loading: false });

    if (isFail) {
      modalProps = {
        msg: data.response.msg,
        modalType: 'ErrorSimple',
        onAccept: null,
      };
    }

    if (data.response && data.response.msg && !isFail) {
      modalProps = {
        msg: data.response.msg,
        modalType: 'SuccessSimple',
        onAccept: null,
      };
      this.setState({ showPaymentView: false });
      if (data.response.status === 'OK') {
        this.props.updateData();
      }
    }
    modal = this.getModal(modalProps);
    this.props.showModal(modal);
  }

  onFailed(data) {
    this.setState({ loading: false });
    data.message = data.message || 'Error';
    const modal = {
      modalType: 'ErrorSimple',
      props: {
        message: data.message,
      },
    };
    this.props.showModal(modal);
  }

  sendRequest() {
    const { form } = this.state;
    form.payway = 'telmexmexicogate';
    this.setState({ form });
    const request = new PaywayChangePaymentMethodTask(
      this.props.config,
      this.state.form,
    );
    RequestManager.addRequest(request)
      .then(this.onSuccess.bind(this))
      .catch(this.onFailed.bind(this));
    this.setState({ loading: true });
  }

  validateForm(event){
    event.preventDefault();
    if (!this.isValidForm()) {
      return;
    }
    this.sendRequest();
  }

  switchPayment = () => {
    this.props.setPayment('plazavipgate');
  }

  render() {
    return this.renderView();
  }
}

PaymentTelmexMexicoGate.propTypes = {
  setPayment: PropTypes.func,
  translations: PropTypes.shape({}),
  showModal: PropTypes.func,
  config: PropTypes.shape({}),
  updateData: PropTypes.func,
};

const mapStateToProps = state => ({
  translations: state.translations,
  metadata: state.metadata,
  user: state.user,
  config: state.config,
  loggedInProfile: state.user.loggedInProfile,
  payway: state.user.paywayData,
});

const mapDispatchToProps = dispatch => ({
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentTelmexMexicoGate);
